import { render, staticRenderFns } from "./template.html?vue&type=template&id=7fea57af&scoped=true&"
import script from "./SidenaviRewardClub.vue?vue&type=script&lang=ts&"
export * from "./SidenaviRewardClub.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=7fea57af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fea57af",
  null
  
)

export default component.exports